import React, { useState, useEffect } from "react";
import "./styles.css";

const Carousel = ({ images }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  // 🔹 Atualiza o slide automaticamente a cada 5s
  useEffect(() => {
    if (!images || images.length === 0) return;
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % images.length);
    }, 1000 * 10);
    return () => clearInterval(interval);
  }, [images]);

  // 🔹 Se não houver imagens, não renderiza nada
  if (!images || images.length === 0) return null;

  const goToSlide = (index) => setActiveIndex(index);

  const prevSlide = () => {
    setActiveIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setActiveIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="carousel" aria-label="Gallery">
      <div className="carousel__viewport">
        {images.map((img, index) => (
          <div key={index} className={`carousel__slide ${index === activeIndex ? "active" : ""}`}>
            <div
              className="carousel__image"
              style={{
                backgroundImage: `url(${img})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            ></div>

            <button className="carousel__prev" onClick={prevSlide}>
              ‹
            </button>
            <button className="carousel__next" onClick={nextSlide}>
              ›
            </button>
          </div>
        ))}
      </div>

      <div className="carousel__navigation">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`carousel__navigation-button ${index === activeIndex ? "active" : ""}`}
          ></button>
        ))}
      </div>
    </section>
  );
};

export default Carousel;
